import { useCallback, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import '@/App.css';
import '@/Website.css';
import { Nav } from '@/components/Nav';
import { Footer } from '@/components/Footer';
import { ScrollToTop } from '@/components/ScrollToTop';
import { JourneyModal } from '@/components/JourneyModal';
import { DiscoveryModal } from '@/components/DiscoveryModal';
import { SearchModal } from '@/components/SearchModal';
import { Home } from '@/pages/Home';
import { AboutUs } from '@/pages/AboutUs';
import { ContactUs } from '@/pages/ContactUs';
import { TermsConditions } from '@/pages/TermsConditions';
import { PrivacyPolicy } from '@/pages/PrivacyPolicy';
import { RefundPolicy } from '@/pages/RefundPolicy';

function App() {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [prefill, setPrefill] = useState('');
  const [discovery, setDiscovery] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);

  const openEnquiry = useCallback((interest = 'General enquiry') => {
    setPrefill(interest);
    setEnquiryOpen(true);
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <MotionConfig reducedMotion="user">
        <div className="App document-site">
          <a href="#experiences" className="skip-link" data-testid="skip-to-content">
            Skip to experiences
          </a>
          <Nav onPlan={() => openEnquiry()} onSearch={() => setSearchOpen(true)} />
          
          <Routes>
            <Route path="/" element={<Home onDiscover={setDiscovery} onEnquire={openEnquiry} />} />
            <Route path="/about-us" element={<AboutUs onEnquire={openEnquiry} />} />
            <Route path="/contact-us" element={<ContactUs onEnquire={openEnquiry} />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/refund-and-cancellation" element={<RefundPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="*" element={<Home onDiscover={setDiscovery} onEnquire={openEnquiry} />} />
          </Routes>

          <Footer onPlan={openEnquiry} onDiscover={setDiscovery} />

          <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} onDiscover={setDiscovery} />
          <DiscoveryModal item={discovery} onClose={() => setDiscovery(null)} onPlan={openEnquiry} />
          <JourneyModal open={enquiryOpen} onClose={() => setEnquiryOpen(false)} prefill={prefill} />
        </div>
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;